var map = {
	"./35.jpg": "68d7",
	"./36.jpg": "a7a8",
	"./37.png": "e75c",
	"./38.png": "c699",
	"./40.png": "5d03",
	"./41.png": "0144",
	"./42.png": "8b9d",
	"./6.jpg": "06d4",
	"./a1.mp4": "3a1a",
	"./a2.mp4": "715d",
	"./a3.mp4": "d935",
	"./a4.mp4": "76d2",
	"./a5.mp4": "0e6e",
	"./about/banner.jpg": "4b75",
	"./about/leader.jpg": "1dc9",
	"./about/qrcode.png": "6887",
	"./app.png": "ea62",
	"./business/address.png": "d73a",
	"./business/address1.png": "794a",
	"./business/address2.png": "d005",
	"./business/banner.jpg": "dc38",
	"./business/co/1.jpg": "1f91",
	"./business/co/10.jpg": "7598",
	"./business/co/11.jpg": "f6f4",
	"./business/co/12.jpg": "2ddf",
	"./business/co/13.jpg": "7515",
	"./business/co/14.jpg": "815e",
	"./business/co/15.jpg": "1fb0",
	"./business/co/16.jpg": "3528",
	"./business/co/17.jpg": "9eda",
	"./business/co/18.jpg": "c42a",
	"./business/co/19.jpg": "9e7e",
	"./business/co/2.jpg": "5731",
	"./business/co/20.jpg": "f575",
	"./business/co/21.jpg": "828b",
	"./business/co/22.jpg": "4df8",
	"./business/co/23.jpg": "05be",
	"./business/co/24.jpg": "c44f",
	"./business/co/25.jpg": "899d",
	"./business/co/26.jpg": "546a",
	"./business/co/27.jpg": "c564",
	"./business/co/28.jpg": "41df",
	"./business/co/29.jpg": "8777",
	"./business/co/3.jpg": "67fc",
	"./business/co/30.jpg": "b4eb",
	"./business/co/31.jpg": "ea9a",
	"./business/co/32.jpg": "40f9",
	"./business/co/33.jpg": "7a85",
	"./business/co/34.jpg": "967b",
	"./business/co/35.jpg": "89a2",
	"./business/co/36.jpg": "ba14",
	"./business/co/37.jpg": "0302",
	"./business/co/38.jpg": "a505",
	"./business/co/39.jpg": "00eb",
	"./business/co/4.jpg": "8bbb",
	"./business/co/40.jpg": "6c24",
	"./business/co/41.jpg": "c45f",
	"./business/co/42.jpg": "6b92",
	"./business/co/43.jpg": "d6a2",
	"./business/co/44.jpg": "9dd9",
	"./business/co/45.jpg": "7062",
	"./business/co/46.jpg": "b752",
	"./business/co/47.jpg": "77dd",
	"./business/co/48.jpg": "d2a4",
	"./business/co/5.jpg": "198d",
	"./business/co/6.jpg": "8cfe",
	"./business/co/7.jpg": "61dd",
	"./business/co/8.jpg": "6a24",
	"./business/co/9.jpg": "7fe4",
	"./business/code1.png": "e9a8",
	"./business/code2.png": "c403",
	"./business/code3.png": "7dbe",
	"./business/code4.png": "eaf7",
	"./business/code5.png": "e31a",
	"./business/code6.png": "8965",
	"./business/jc.jpg": "ff60",
	"./business/next.png": "7fd0",
	"./business/phone.png": "d787",
	"./business/phone1.png": "a139",
	"./business/phone2.png": "f473",
	"./business/prev.png": "832e",
	"./business/slide1.jpg": "f63a",
	"./business/slide2.jpg": "c980",
	"./business/slide3.jpg": "d82f",
	"./business/slide4.jpg": "097a",
	"./business/slide5.jpg": "784c",
	"./business/slide6.jpg": "c068",
	"./business/swiper1.jpg": "a39f",
	"./business/swiper2.jpg": "a72e",
	"./business/swiper3.jpg": "741d",
	"./business/swiper4.jpg": "a1d7",
	"./corporate/banner.jpg": "1880",
	"./corporate/slider1.jpg": "ffa6",
	"./corporate/slider2.jpg": "3c92",
	"./corporate/slider3.jpg": "3ce4",
	"./corporate/slider4.jpg": "770c",
	"./corporate/slider5.jpg": "7d14",
	"./corporate/slider6.jpg": "1adb",
	"./corporate/slider7.jpg": "350d",
	"./dwell/1.jpg": "7e1e",
	"./dwell/2.jpg": "e97e",
	"./dwell/3.jpg": "7bbc",
	"./dwell/a1.jpg": "a8c4",
	"./dwell/a2.jpg": "bf7b",
	"./dwell/a3.jpg": "32e9",
	"./dwell/a4.jpg": "3ab4",
	"./dwell/a5.jpg": "9946",
	"./dwell/a6.jpg": "3e78",
	"./dwell/banner.jpg": "f5b1",
	"./dwell/banner_fh.jpg": "6f8d",
	"./dwell/banner_wl.jpg": "eb48",
	"./dwell/banner_wlx.jpg": "ee37",
	"./dwell/banner_xg.jpg": "166f",
	"./dwell/fh_code_1.png": "1521",
	"./dwell/fh_code_2.png": "f769",
	"./dwell/fh_code_3.png": "acb2",
	"./dwell/fh_code_4.png": "4743",
	"./dwell/fh_code_5.png": "d2d9",
	"./dwell/fh_code_6.png": "e5c9",
	"./dwell/fh_slider1.jpg": "695a",
	"./dwell/fh_slider2.jpg": "89e2",
	"./dwell/fh_slider3.jpg": "5ba1",
	"./dwell/fh_slider4.jpg": "406d",
	"./dwell/fh_slider5.jpg": "dcb9",
	"./dwell/fh_slider6.jpg": "c661",
	"./dwell/icon_1.png": "38b7",
	"./dwell/icon_2.png": "b7f8",
	"./dwell/icon_3.png": "99ba",
	"./dwell/icon_4.png": "7bda",
	"./dwell/icon_5.png": "5b4c",
	"./dwell/icon_6.png": "c1ad",
	"./dwell/icon_big.png": "b1ff",
	"./dwell/wl_code_1.png": "0b59",
	"./dwell/wl_code_2.png": "2a13",
	"./dwell/wl_prod1_1.jpg": "26b6",
	"./dwell/wl_prod1_2.jpg": "e57d",
	"./dwell/wl_prod1_3.jpg": "153d",
	"./dwell/wl_prod1_4.jpg": "d312",
	"./dwell/wl_prod1_5.jpg": "9786",
	"./dwell/wl_prod1_6.jpg": "117e",
	"./dwell/wl_prod1_7.jpg": "b64b",
	"./dwell/wl_prod2_1.jpg": "7282",
	"./dwell/wl_prod2_2.jpg": "1632",
	"./dwell/wl_prod2_3.jpg": "9c85",
	"./dwell/wl_prod2_4.jpg": "a2c3",
	"./dwell/wl_sl1.jpg": "c7ab",
	"./dwell/wl_sl2.jpg": "17cd",
	"./dwell/wl_sl3.jpg": "d284",
	"./dwell/wl_sl4.jpg": "87f1",
	"./dwell/wl_slider1.jpg": "a96d",
	"./dwell/wl_slider2.jpg": "c5b4",
	"./dwell/wl_v1.png": "a58f",
	"./dwell/wl_v2.png": "afed",
	"./dwell/wl_v3.png": "1ae4",
	"./dwell/wlx_code_1.png": "08f1",
	"./dwell/wlx_code_2.png": "ca5e",
	"./dwell/xg_code_1.png": "c7fc",
	"./dwell/xg_slider1.jpg": "bdbe",
	"./elegance/1.jpg": "cc75",
	"./elegance/2.jpg": "cde1",
	"./elegance/3.jpg": "a7b0",
	"./elegance/4.jpg": "3465",
	"./elegance/5.jpg": "37cc",
	"./elegance/6.jpg": "c933",
	"./elegance/banner.jpg": "8128",
	"./error.jpg": "f6de",
	"./exchange/1.png": "1843",
	"./exchange/2.png": "c70d",
	"./exchange/3.png": "daca",
	"./exchange/4.png": "f89b",
	"./exchange/arrow-right.png": "cad5",
	"./exchange/arrow_down.png": "f44d",
	"./exchange/arrow_down_active.png": "c9ea",
	"./exchange/banner.jpg": "3e4c",
	"./exchange/code.png": "0b9a",
	"./exchange/code_icon.png": "5c9f",
	"./exchange/ditu.png": "c3c1",
	"./exchange/house1.jpg": "2d3d",
	"./exchange/house1_icon.png": "2533",
	"./exchange/house2.jpg": "55d4",
	"./exchange/house2_icon.png": "c0fd",
	"./exchange/play.png": "2be2",
	"./exchange/poster1.png": "7bd2",
	"./exchange/poster2.png": "aa2a",
	"./exchange/video1_1.mp4": "cbd6",
	"./exchange/video1_2.mp4": "91d0",
	"./exchange/video2.mp4": "1d40",
	"./footer/checkmark-white.svg": "3529",
	"./footer/close.png": "bcf8",
	"./footer/icon-arrow-left.svg": "d0100",
	"./footer/icon-checkmark-teal.svg": "8234",
	"./footer/icon-contact.svg": "a537",
	"./footer/icon-customer-service.svg": "7fc2",
	"./footer/icon-facebook.svg": "3fec",
	"./footer/icon-form-field-option-checked.svg": "7d80",
	"./footer/icon-form-field-toggle.svg": "977f",
	"./footer/icon-instagram.svg": "1f50",
	"./footer/icon-linkedin.svg": "267e",
	"./footer/icon-twitter.svg": "a801",
	"./footer/icon-wechat.svg": "7919",
	"./footer/icon-weibo.svg": "1fb4",
	"./home_right/fzlc.jpg": "db4c",
	"./home_right/jdjy.jpg": "cca2",
	"./home_right/jhjs.jpg": "704a",
	"./home_right/kfzx.jpg": "57c8",
	"./home_right/khfw.jpg": "3dd2",
	"./home_right/qyry.jpg": "d73b",
	"./home_right/qywh.jpg": "2f17",
	"./home_right/sykf.jpg": "6d0b",
	"./home_right/wyyy.jpg": "0ad5",
	"./home_right/xwzx.jpg": "a37d",
	"./home_right/zzkf.jpg": "8e1b",
	"./honor/banner.jpg": "a8cb",
	"./honor/bg.png": "086b",
	"./honor/left_arrow.png": "288a",
	"./honor/next_black_icon.png": "2269",
	"./honor/next_gray_icon.png": "8f38",
	"./honor/pre_black_icon.png": "1dbb",
	"./honor/pre_gray_icon.png": "7bdf",
	"./honor/right_arrow.png": "3367",
	"./hotel/aa.png": "cc40",
	"./hotel/banner.jpg": "d801",
	"./hotel/banner_code.png": "573a",
	"./hotel/cate1.jpg": "b231",
	"./hotel/cate2.jpg": "47ca",
	"./hotel/cate3.jpg": "b18b",
	"./hotel/close.png": "3644",
	"./hotel/hotel1.png": "20ca",
	"./hotel/hotel1_1.png": "f3d2",
	"./hotel/hotel1_2.png": "36a5",
	"./hotel/hotel1_3.png": "8bef",
	"./hotel/hotel1_4.png": "243f",
	"./hotel/hotel1_min.png": "cd92",
	"./hotel/hotel2.png": "dde0",
	"./hotel/hotel2_1.png": "7ecd",
	"./hotel/hotel2_2.png": "4293",
	"./hotel/hotel2_3.png": "2e7a",
	"./hotel/hotel2_4.png": "9ee8",
	"./hotel/hotel2_min.png": "7138",
	"./hotel/hotel3_1.png": "ae9d",
	"./hotel/hotel3_2.png": "0e01",
	"./hotel/hotel3_3.png": "a3b4",
	"./hotel/hotel3_4.png": "c301",
	"./hotel/hotel3_min.png": "7cd9",
	"./hotel/hotel_1.png": "41eb",
	"./hotel/hotel_2.png": "da04",
	"./hotel/hotel_3.png": "82ed",
	"./hotel/icon_1.png": "3b10",
	"./hotel/icon_2.png": "b8fd",
	"./hotel/icon_3.png": "a35c",
	"./hotel/map2.png": "d269",
	"./hotel/play.png": "1958",
	"./hotel/poster_1.jpg": "a4b1",
	"./hotel/poster_2.jpg": "f6c4",
	"./hotel/poster_3.jpg": "ea0d",
	"./hotel/slide11.png": "23dd",
	"./hotel/slide12.png": "c1b2",
	"./hotel/slide13.png": "26a0",
	"./hotel/slide14.png": "2db6",
	"./hotel/slide15.png": "b945",
	"./hotel/slide21.png": "fea6",
	"./hotel/slide22.png": "246e",
	"./hotel/slide23.png": "3f1f",
	"./hotel/slide24.png": "002c",
	"./hotel/slide25.png": "bc6c",
	"./hotel/video1.mp4": "1197",
	"./hotel/video2.mp4": "3a70",
	"./hotel/video3.mp4": "bb45",
	"./icon-close.svg": "9e40",
	"./jhcode.jpg": "af06",
	"./join/13.jpg": "310a",
	"./join/banner.jpg": "c93d",
	"./join/fire.png": "0571",
	"./logo.png": "cf05",
	"./logo_top.png": "5f36",
	"./logobig.png": "80bc",
	"./myservice/1.png": "1712",
	"./myservice/2.png": "c562",
	"./myservice/28.png": "cfab",
	"./myservice/29.png": "bea6",
	"./myservice/3.png": "bd1a",
	"./myservice/30.png": "81d9",
	"./myservice/31.png": "2423",
	"./myservice/4.png": "7bcc",
	"./myservice/5.png": "ef9c",
	"./myservice/6.png": "527d",
	"./myservice/banner.jpg": "2eb9",
	"./myservice/ln.jpg": "03d3",
	"./myservice/ls.jpg": "587e",
	"./myservice/ls2.jpg": "6a3c",
	"./myservice/mincode.png": "6007",
	"./myservice/qrcode.png": "aec4",
	"./myservice/right.png": "d529",
	"./myservice/s1.png": "8c13",
	"./myservice/s2.png": "c068b",
	"./myservice/s3.png": "afbc",
	"./myservice/s4.png": "bdc3",
	"./myservice/to.png": "605e",
	"./news/0.png": "c4bd",
	"./news/1.png": "fd08",
	"./news/2.png": "205e",
	"./news/3.png": "ba47",
	"./news/arrow.png": "a424",
	"./news/banner.jpg": "f02a",
	"./news/en.png": "494e",
	"./news/jt_icon.png": "aade",
	"./news/search.png": "a06e",
	"./news/sx.png": "6532",
	"./nio/banner.jpg": "bee8",
	"./nio/icon1.png": "14b0",
	"./nio/icon2.png": "0e0b",
	"./nio/icon3.png": "11d0",
	"./nio/icon4.png": "cd35",
	"./nio/icon5.png": "f1f3",
	"./nio/icon6.png": "c921",
	"./nio/img1.jpg": "c37e",
	"./nio/img2.jpg": "ff16",
	"./nio/img3.jpg": "85f1",
	"./nio/img4.jpg": "79fb",
	"./nio/img5.jpg": "3fba",
	"./nio/img6.jpg": "1dd2",
	"./poster_0.jpg": "9be9",
	"./poster_0.png": "9ccf",
	"./poster_00.jpg": "8c33",
	"./poster_00.png": "3a87",
	"./poster_01.jpg": "d472",
	"./poster_01.png": "5c55",
	"./poster_011.jpg": "9797",
	"./poster_011.png": "c62a",
	"./poster_1.png": "11bc",
	"./poster_2.png": "e775",
	"./poster_3.png": "a970",
	"./poster_4.png": "cb24",
	"./poster_5.png": "a5c8",
	"./poster_a00.jpg": "387c",
	"./poster_a01.jpg": "1f6b",
	"./real/banner.jpg": "f88d",
	"./real/gh.png": "5840",
	"./real/gx.png": "b68e",
	"./real/honor_bg1.png": "27f4",
	"./real/honor_bg2.png": "b1c44",
	"./real/honor_bg3.png": "b7c2",
	"./real/honor_bg4.png": "9cbc",
	"./real/icon_pic.png": "d6a4",
	"./real/ll.png": "59cf",
	"./real/map_bg.png": "c1d4",
	"./real/phone_icon.png": "09e3",
	"./real/poster_1.png": "be18",
	"./real/qrcode.png": "7965",
	"./real/swiper1.png": "603f",
	"./real/swiper2.png": "1889",
	"./real/swiper3.png": "bd94",
	"./real/swiper4.png": "390d",
	"./real/swiper5.png": "d5bb",
	"./real/swiper6.png": "1d34",
	"./real/sy.png": "3680",
	"./real/video1.mp4": "b6f8",
	"./real/wx1.jpg": "8f3b",
	"./real/wx2.jpg": "3441",
	"./real/wx3.jpg": "44e6",
	"./real/wx4.jpg": "5226",
	"./real/zn.png": "9438",
	"./real/zx.png": "ce6d",
	"./service/27.jpg": "b1c4",
	"./service/28.jpg": "7749",
	"./service/29.jpg": "35b5",
	"./service/30.jpg": "0724",
	"./service/31.jpg": "f89a",
	"./service/32.jpg": "6fbc",
	"./visioncar/banner.jpg": "f4cf",
	"./yw/1.jpg": "3cb7",
	"./yw/2.jpg": "1d47",
	"./yw/3.jpg": "1076",
	"./yw/4.jpg": "0a1f",
	"./yw/5.jpg": "0403"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";